/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { DocumentFilterInnerV2Dto } from '../models/DocumentFilterInnerV2Dto';
import type { DocumentPaginatedV2Dto } from '../models/DocumentPaginatedV2Dto';
import type { DocumentSimplePaginatedV2Dto } from '../models/DocumentSimplePaginatedV2Dto';
import type { DocumentType } from '../models/DocumentType';
import type { DocumentV1Dto } from '../models/DocumentV1Dto';
import type { OrderByRelationalPropertyDto } from '../models/OrderByRelationalPropertyDto';
import type { PatchDocumentStampedV1Dto } from '../models/PatchDocumentStampedV1Dto';
import type { PatchDocumentV1Dto } from '../models/PatchDocumentV1Dto';
import type { UploadDocumentRequestV1 } from '../models/UploadDocumentRequestV1';
import type { UploadManyDocumentsRequestV1 } from '../models/UploadManyDocumentsRequestV1';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsService {
  /**
   * @deprecated
   * @returns DocumentV1Dto a entity list
   * @throws ApiError
   */
  public static documentControllerV1FindAllV1(): CancelablePromise<Array<DocumentV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/documents',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Upload a new Document
   * Upload a new document to the storage
   * @param formData
   * @returns DocumentV1Dto create entity
   * @throws ApiError
   */
  public static documentControllerV1UploadOneDocumentV1(
    formData: UploadDocumentRequestV1,
  ): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/documents',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static documentControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/documents',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Batch upload documents
   * Upload documents to the storage
   * @param formData
   * @returns DocumentV1Dto create entity
   * @throws ApiError
   */
  public static documentControllerV1UploadManyDocumentsV1(
    formData: UploadManyDocumentsRequestV1,
  ): CancelablePromise<Array<DocumentV1Dto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/documents/batch',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Get document information.
   * get details of a document by its uuid
   * @param uuid The uuid of the document to update
   * @returns DocumentV1Dto the entity
   * @throws ApiError
   */
  public static documentControllerV1FindOneV1(uuid: string): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/documents/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid documentId
   * @param requestBody
   * @returns DocumentV1Dto the update entity
   * @throws ApiError
   */
  public static documentControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchDocumentV1Dto,
  ): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/documents/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid documentId
   * @returns DocumentV1Dto the entity
   * @throws ApiError
   */
  public static documentControllerV1RemoveOneV1(uuid: string): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/documents/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid documentId
   * @param requestBody
   * @returns DocumentV1Dto the update entity
   * @throws ApiError
   */
  public static documentControllerV1UpdatePartialDocumentStampV1(
    uuid: string,
    requestBody: PatchDocumentStampedV1Dto,
  ): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/documents/{uuid}/stamp',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid documentId
   * @param requestBody
   * @returns DocumentV1Dto the update entity
   * @throws ApiError
   */
  public static documentControllerV1UpdatePartialDocumentFinalStampV1(
    uuid: string,
    requestBody: PatchDocumentStampedV1Dto,
  ): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/documents/{uuid}/final-stamp',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Download a document.
   * Download a document from the storage.
   * @param uuid The uuid of the document to download
   * @returns binary
   * @throws ApiError
   */
  public static documentControllerV1DownloadDocumentV1(uuid: string): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/documents/{uuid}/download',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid
   * @param ticketUuid
   * @returns DocumentV1Dto the entity
   * @throws ApiError
   */
  public static documentControllerV1RemoveTicketRelationV1(
    uuid: string,
    ticketUuid: string,
  ): CancelablePromise<DocumentV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/documents/{uuid}/ticket/{ticketUuid}',
      path: {
        uuid: uuid,
        ticketUuid: ticketUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param orderBy Array of DocumentBaseV2Dto order by properties (supports relations with dot-notation)
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying documents
   * @param searchString A search string to filter DocumentV2Dto by given values.
   * @param documentType Look for documents of a specific type.
   * @param isClassified Indicates if the document is classified.
   * @param ticketId Filter documents by ticket ID.
   * @returns DocumentPaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static documentControllerV2FindAllV2(
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: DocumentFilterInnerV2Dto | null,
    searchString?: string | null,
    documentType?: DocumentType,
    isClassified?: boolean,
    ticketId?: string,
  ): CancelablePromise<DocumentPaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/documents',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        documentType: documentType,
        isClassified: isClassified,
        ticketId: ticketId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param orderBy Array of DocumentBaseV2Dto order by properties (supports relations with dot-notation)
   * @param page Page number (starts at 1). Used for paginated queries. Must be a positive integer.
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @param filter Filter conditions for querying documents
   * @param searchString A search string to filter DocumentV2Dto by given values.
   * @param documentType Look for documents of a specific type.
   * @param isClassified Indicates if the document is classified.
   * @param ticketId Filter documents by ticket ID.
   * @returns DocumentSimplePaginatedV2Dto a entity list wrapped with pagination result
   * @throws ApiError
   */
  public static documentControllerV2FindAllSimpleV2(
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    page?: number,
    limit?: number,
    filter?: DocumentFilterInnerV2Dto | null,
    searchString?: string | null,
    documentType?: DocumentType,
    isClassified?: boolean,
    ticketId?: string,
  ): CancelablePromise<DocumentSimplePaginatedV2Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/documents/simple',
      query: {
        orderBy: orderBy,
        page: page,
        limit: limit,
        filter: filter,
        searchString: searchString,
        documentType: documentType,
        isClassified: isClassified,
        ticketId: ticketId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
